import React, { Component, createRef  } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { isEmpty } from "lodash";

import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Container,
  Label,
} from "reactstrap";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin, { Draggable } from "@fullcalendar/interaction";
import BootstrapTheme from "@fullcalendar/bootstrap";
//css
import "@fullcalendar/bootstrap/main.css";
import {
  getEvents,
  addNewEvent,
  updateEvent,
  deleteEvent,
  getCategories,
} from "../../../store/actions";
import DeleteModal from "./DeleteModal";
import Breadcrumbs from "components/Common/Breadcrumb";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import LeaveApply from "./LeaveApply";
import { decryptData, urlDecryptData } from "helpers/crypto_helper";

const statusColors = {
  "LOP": "#C0392B",
  "Leave": "#27AE60",  
  "Permission": "#F4D03F",
  "On Duty": "#8E44AD",
  "Half Day": "#F39C12"
};

const statusStyles = {
  "Present":    { short: "P",   color: "#27AE60", text: "#fff" },
  "CL":         { short: "CL",  color: "#27AE60", text: "#fff" },
  "SL":         { short: "SL",  color: "#27AE60", text: "#fff" },
  "Leave":      { short: "L",   color: "#27AE60", text: "#fff" },
  "Permission": { short: "PR",  color: "#F4D03F", text: "#000" },
  "On Duty":    { short: "OD",  color: "#8E44AD", text: "#fff" },
  "Half Day":   { short: "HD",  color: "#F39C12", text: "#fff" },
  "LOP":        { short: "LOP", color: "#C0392B", text: "#fff" },
  "Week Off":   { short: "WO",  color: "#5DADE2", text: "#fff" },
  "Holiday":    { short: "H",   color: "#48C9B0", text: "#fff" },
  "Absent":     { short: "A",   color: "#7F8C8D", text: "#fff" }
};


class MyAttendance extends Component {
  constructor(props) {
    super(props);
    this.handleDateClick = this.handleDateClick.bind(this);
    this.calendarComponentRef = React.createRef();
    this.calendarRef = createRef();
    this.state = {
      calendarWeekends: true,
      modal: false,
      modalcategory: false,
      isDragBind: false,
      deleteModal: false,
      event: {},
      authDetails: null,
      eventsArray: [],
      pendingModalInfo: null,     
      isMonthLoading: false,        
      calendarKey: 0   ,
      currentViewDate:null,
      requestedMonthKey: null, 
      userID: null,
       employeeCode: "",
       employeeName: "",
    };

    this.toggle = this.toggle.bind(this);
    this.togglecategory = this.togglecategory.bind(this);
    this.handleValidEventSubmitcategory =
      this.handleValidEventSubmitcategory.bind(this);

    // category
    this.onDrag = this.onDrag.bind(this);
    this.onDrop = this.onDrop.bind(this);
  }

  componentDidMount = () => {
    const { onGetCategories, onGetEvents } = this.props;
    onGetCategories();
    onGetEvents();
     // ✅ Handle URL param decrypt logic
    const searchParams = new URLSearchParams(this.props.location.search);
    const encryptedId = searchParams.get("id");

    if (encryptedId) {
      try {
        const decryptedId = urlDecryptData(encryptedId);
        console.log('decryptedId > ',decryptedId)
        this.setState({ userID: decryptedId});
      } catch (error) {
        console.error("Failed to decrypt empID from URL:", error);
      }
    } 
    document.addEventListener("click", this.handleEventClick);
      // document.addEventListener("click", (e) => {
      //   const badge = e.target.closest(".badge-leave");
      //   if (badge) {
      //     const date = badge.getAttribute("data-date");
      //     const type = badge.getAttribute("data-type");
      //     this.handleBadgeClick(type, date);
      //     this.fetchAttendancePopup(date);
      //   }
      // });
    // new Draggable(document.getElementById("external-events"), {
    //   itemSelector: ".external-event",
    // });
  };

  formatDate = (isoDate) => {
    const d = new Date(isoDate);
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  };


  handleBadgeClick = (type, date) => {
    // Store clicked info
    this.setState({ pendingModalInfo: { type, date } });

    // Fetch fresh popup data
    this.fetchAttendancePopup(date);
  };

  openLeaveModal = (type, date) => {
    const formattedDate = this.formatDate(date); // e.g. 15/09/2025
    const data = this.props.popupData || {};

    let selectedDetails = [];
    let title = "";

    switch (type) {
      case "CL":
      case "SL":
      case "LOP":
        selectedDetails = data.leave_details?.filter(d => d.leave_dt === formattedDate) || [];
        title = "Leave Details";
        break;
      case "On Duty":
      case "OD":
        selectedDetails = data.od_details?.filter(d => d.leave_dt === formattedDate) || [];
        title = "On Duty Details";
        break;
      case "Permission":
        selectedDetails = data.per_details?.filter(d => d.leave_dt === formattedDate) || [];
        title = "Permission Details";
        break;
      case "Half Day":
        selectedDetails = data.leave_details?.filter(d => d.leave_dt === formattedDate) || [];
        title = "Half Day Details";
        break;
      default:
        selectedDetails = [];
        title = `${type} Details`;
    }

    this.setState({
      isLeaveModalOpen: true,
      leaveModalTitle: title,
      leaveModalData: selectedDetails,
    });
  };

  closeLeaveModal = () => {
    this.setState({
      isLeaveModalOpen: false,
      leaveModalTitle: "",
      leaveModalData: [],
    });
  };


  componentWillUnmount() {
    document.removeEventListener("click", this.handleEventClick);
  }

  // eslint-disable-next-line no-unused-vars
  // componentDidUpdate(prevProps, prevState, snapshot) {
  //   const { event, modal } = this.state;
  //   if (prevState.modal !== modal && !modal && !isEmpty(event)) {
  //     setTimeout(() => {
  //       this.setState({ event: {}, isEdit: false });
  //     }, 500);
  //   }
  // }

componentDidUpdate(prevProps) {
  const { pendingModalInfo, currentViewDate, requestedMonthKey } = this.state;

  if (
    prevProps.events !== this.props.events &&
    this.props.events &&
    typeof this.props.events === "object"
  ) {
    this.setState({
      employeeCode: this.props.events.emp_no || "-",
      employeeName: this.props.events.first_name || "-"
    });
  }
  // Track live events changes
   if (prevProps.events !== this.props.events && this.props.events && currentViewDate) {
    const year = currentViewDate.getFullYear();
    const month = currentViewDate.getMonth();
    const monthStart = new Date(year, month, 1);
    const monthEnd = new Date(year, month + 1, 0);

    const events = this.prepareEvents(this.props.events, monthStart, monthEnd);

    this.setState({ eventsArray: events, isMonthLoading: false }, () => {
      // ⚡ Wait a tick to ensure events are rendered, then trigger dayCellDidMount logic
      setTimeout(() => {
        const calendarApi = this.calendarRef.current?.getApi();
        if (calendarApi) {
          calendarApi.refetchEvents(); // Forces FullCalendar to rerender events and call dayCellDidMount
        }
      }, 100); // 100ms delay
    });
  }

  if (prevProps.popupData !== this.props.popupData && pendingModalInfo) {
    const { type, date } = pendingModalInfo;
    if (this.props.popupData) {
      this.openLeaveModal(type, date);
      this.setState({ pendingModalInfo: null });
    }
  }
}


  /**
   * Handling the modal state
   */
  toggle() {
    this.setState(prevState => ({
      modal: !prevState.modal, // only toggle
      eventsArray: this.prepareEvents(this.props.events)
    }));
  }

  togglecategory() {
    this.setState(prevState => ({
      modalcategory: !prevState.modalcategory,
    }));
  }

  onLeaveApplySuccess = () => {
    this.toggle(); // close modal
    const { userID,authDetails, selectedDay } = this.state;
    if (!authDetails || !selectedDay) return;

    const formData = new FormData();
    formData.append("date", selectedDay.date.toISOString().split("T")[0]);
    formData.append("unit_id", authDetails.unit_id);
    formData.append("create_by", userID || (authDetails && authDetails.user_id));

    // Fetch updated attendance events
    this.props.fetchEmployeeAttendanceSaga(formData);
  };

  /**
   * Handling date click on calendar
   */
  // handleDateClick = arg => {
  //   const date = arg["date"];
  //   const day = date.getDate();
  //   const month = date.getMonth();
  //   const year = date.getFullYear();

  //   const currectDate = new Date();
  //   const currentHour = currectDate.getHours();
  //   const currentMin = currectDate.getMinutes();
  //   const currentSec = currectDate.getSeconds();
  //   const modifiedDate = new Date(
  //     year,
  //     month,
  //     day,
  //     currentHour,
  //     currentMin,
  //     currentSec
  //   );
  //   const modifiedData = { ...arg, date: modifiedDate };

  //   this.setState({ selectedDay: modifiedData });
  //   this.toggle();
  // };

  handleDateClick = (arg) => {
  const modifiedData = {
    ...arg,
    date: new Date(
      arg.date.getFullYear(),
      arg.date.getMonth(),
      arg.date.getDate(),
      new Date().getHours(),
      new Date().getMinutes(),
      new Date().getSeconds()
    ),
  };

  const { authDetails } = this.state;
  const selectedDate = arg.dateStr;
  // dispatch saga
  this.fetchAttendancePopup(selectedDate);

  this.setState({ selectedDay: modifiedData, modal: true }); // just open modal
};

  /**
   * Handling click on event on calendar
   */
  // handleEventClick = arg => {
  //   const event = arg.event;
  //   this.setState({
  //     event: {
  //       id: event.id,
  //       title: event.title,
  //       title_category: event.title_category,
  //       start: event.start,
  //       className: event.classNames,
  //       category: event.classNames[0],
  //       event_category: event.classNames[0],
  //     },
  //     isEdit: true,
  //   });
  //   this.toggle();
  // };

  handleValidEventSubmitcategory = (event, values) => {
    const { onAddNewEvent } = this.props;

    const newEvent = {
      id: Math.floor(Math.random() * 100),
      title: values["title_category"],
      start: new Date(),
      className: values.event_category
        ? values.event_category + " text-white"
        : "bg-danger text-white",
    };
    // save new event
    onAddNewEvent(newEvent);
    this.togglecategory();
  };

  /**
   * On delete event
   */
  handleDeleteEvent = () => {
    const { onDeleteEvent } = this.props;
    const { event } = this.state;

    onDeleteEvent(event);
    this.setState({ deleteModal: false });
    this.toggle();
  };

  /**
   * On category darg event
   */
  onDrag = event => {
    event.preventDefault();
  };

  /**
   * On calendar drop event
   */
  onDrop = event => {
    const date = event["date"];
    const day = date.getDate();
    const month = date.getMonth();
    const year = date.getFullYear();

    const currectDate = new Date();
    const currentHour = currectDate.getHours();
    const currentMin = currectDate.getMinutes();
    const currentSec = currectDate.getSeconds();
    const modifiedDate = new Date(
      year,
      month,
      day,
      currentHour,
      currentMin,
      currentSec
    );

    const { onAddNewEvent } = this.props;
    const draggedEl = event.draggedEl;
    const modifiedData = {
      id: Math.floor(Math.random() * 100),
      title: draggedEl.innerText,
      start: modifiedDate,
      className: draggedEl.className,
    };
    onAddNewEvent(modifiedData);
  };


   // Convert 12h → 24h
  convertTo24Hour = (timeStr) => {
    if (!timeStr) return null;
    const match = timeStr.trim().match(/^(\d{1,2}):(\d{2})(?:\s*(AM|PM))?$/i);
    if (!match) return null;
    let hour = parseInt(match[1], 10);
    const minute = match[2];
    const ampm = match[3]?.toUpperCase();
    if (ampm) {
      if (ampm === "AM" && hour === 12) hour = 0;
      else if (ampm === "PM" && hour !== 12) hour += 12;
    }
    return `${String(hour).padStart(2, "0")}:${minute}:00`;
  };


 // Prepare events for FullCalendar
  prepareEvents = (data, monthStart, monthEnd) => {
  const events = Object.entries(data).map(([date, d]) => ({
    start: date,
    allDay: true,
    extendedProps: {
      shift: d.shift || "-",
      inTime: d.punch_in?.trim() || "-",
      outTime: d.punch_out?.trim() || "-",
      workedHrs: d.worked_hours ? d.worked_hours.replace("hrs","h").replace("mins","m") : "0h",
      timesheet: d.timesheet || "0h",
      status: d.status || "Regular",
      leave_type: d.leave_type || "-",
      holiday_name: d.holiday_name || "-",
      textColor: statusColors[d.status] || "#2C3E50",
    }
  }));

  // Fill missing days in current month grid
  let current = new Date(monthStart);
  const end = new Date(monthEnd);
  while (current <= end) {
    const dateStr = current.toISOString().split("T")[0];
    if (!events.find(e => e.start === dateStr)) {
      events.push({
        start: dateStr,
        allDay: true,
        extendedProps: { status: "Regular", textColor: "#2C3E50" }
      });
    }
    current.setDate(current.getDate() + 1);
  }

  return events;
};


eventContentFunction = (arg) => {
  const e = arg.event.extendedProps;
  const rawStatus = e.status || null;
  const leaveType = e.leave_type || "";

  // --- Determine the correct status key ---
  let statusKey = rawStatus;
  if (rawStatus === "Leave") {
    if (leaveType.includes("CL")) statusKey = "CL";
    else if (leaveType.includes("SL")) statusKey = "SL";
    else if (leaveType.includes("LOP")) statusKey = "LOP";
  }

  // --- Color mapping ---
  const statusStyles = {
    "CL": { short: "CL", color: "#27AE60", text: "#fff" },
    "SL": { short: "SL", color: "#27AE60", text: "#fff" },
    "LOP": { short: "LOP", color: "#C0392B", text: "#fff" },
    "Permission": { short: "P", color: "#F4D03F", text: "#000" },
    "On Duty": { short: "OD", color: "#8E44AD", text: "#fff" },
    "Half Day": { short: "HD", color: "#F39C12", text: "#fff" },
    "Week Off": { short: "WO", color: "#5DADE2", text: "#fff" },
    "Holiday": { short: "H", color: "#48C9B0", text: "#27AE60" },
  };

  const style = statusStyles[statusKey] || null;

  // --- Holiday ---
  if (rawStatus === "Holiday") {
    return {
      html: `
        <div style="text-align:center;line-height:1.8;padding:5px;">
          <div style="font-size:14px;font-weight:700;color:${style.text};">
            ${e.holiday_name || "Holiday"}
          </div>
        </div>
      `
    };
  }

  // --- Leave / Permission / On Duty / Half Day (show badge + shift + time) ---
if (["CL", "SL", "LOP", "Permission", "On Duty", "Half Day"].includes(statusKey)) {
  const shiftLine =
    e.shift && e.shift.trim() !== "-" && e.shift.trim() !== ""
      ? `<div class="shift-line" data-date="${arg.event.startStr}"
          style="color:#2C3E50;cursor:pointer;font-size:12px;font-weight:600;margin-bottom:4px;">
          Shift: ${e.shift}
        </div>`
      : "";

  const timeLine =
    e.inTime && e.inTime.trim() !== "-" && e.inTime.trim() !== "" &&
    e.outTime && e.outTime.trim() !== "-" && e.outTime.trim() !== ""
      ? `<div class="time-line" data-date="${arg.event.startStr}"
          style="color:#1F618D;cursor:pointer;font-size:12px;font-weight:600;">
          ⏰ ${e.inTime} / ${e.outTime}
        </div>`
      : "";

  return {
    html: `
      <div style="text-align:center;line-height:1.8;padding:5px;">
        ${shiftLine}
        ${timeLine}
        <div 
          class="badge-leave"
          data-type="${statusKey}" 
          data-date="${arg.event.startStr}"
          style="
            display:inline-flex;
            align-items:center;
            justify-content:center;
            background:${style.color};
            color:${style.text};
            font-size:14px;
            font-weight:700;
            border-radius:50%;
            width:42px;
            height:42px;
            margin:auto;
            cursor:pointer;
            box-shadow:0 1px 4px rgba(0,0,0,0.25);
          "
        >
          ${style.short}
        </div>
      </div>
    `
  };
}

  // --- Week Off ---
  if (statusKey === "Week Off") {
    return {
      html: `
        <div style="text-align:center;">
          <div style="
            display:inline-flex;
            align-items:center;
            justify-content:center;
            background:${style.color};
            color:${style.text};
            font-size:14px;
            font-weight:700;
            border-radius:50%;
            width:42px;
            height:42px;
            margin:auto;
            box-shadow:0 1px 4px rgba(0,0,0,0.25);
          ">
            ${style.short}
          </div>
        </div>
      `
    };
  }

  // --- Regular Working Day or status null ---
  const lines = [];

  // Shift
  if (e.shift && e.shift.trim() !== "-" && e.shift.trim() !== "") {
    lines.push(`<div class="shift-line" data-date="${arg.event.startStr}"
      style="color:#2C3E50;cursor:pointer;font-size:13px;font-weight:600;">
      Shift: ${e.shift}
    </div>`);
  }

  // Show only if at least one time is available
  const hasIn = e.inTime && e.inTime.trim() !== "-" && e.inTime.trim() !== "";
  const hasOut = e.outTime && e.outTime.trim() !== "-" && e.outTime.trim() !== "";

  if (hasIn || hasOut) {
    const inVal = hasIn ? e.inTime : "-";
    const outVal = hasOut ? e.outTime : "-";

    lines.push(`
      <div class="time-line" data-date="${arg.event.startStr}"
        style="color:#1F618D;margin-top:3px;cursor:pointer;font-size:12px;font-weight:600;">
        ⏰ ${inVal} / ${outVal}
      </div>
    `);
  }

  // Worked hours & timesheet
  const workedValid = e.workedHrs && e.workedHrs.trim() !== "0h" && e.workedHrs.trim() !== "";
  const timesheetValid = e.timesheet && e.timesheet.trim() !== "0h" && e.timesheet.trim() !== "";

  if (workedValid || timesheetValid) {
    lines.push(`<div style="font-size:10px;margin-top:4px;font-weight:500;">
      ${workedValid ? `<span style="color:#27AE60;font-weight:600;">⏱ ${e.workedHrs}</span>` : ""}
      ${workedValid && timesheetValid ? "&nbsp;|&nbsp;" : ""}
      ${timesheetValid ? `<span style="color:#2980B9;font-weight:600;">📝 ${e.timesheet}</span>` : ""}
    </div>`);
  }

  // Return if any lines exist
  if (lines.length > 0) {
    return { html: `<div style="text-align:left;line-height:2.2;padding:3px;">${lines.join("")}</div>` };
  }

  // --- Empty fallback ---
  return { html: `<div style="text-align:center;padding:5px;"></div>` };
};

  // Handle month / view change
handleDatesSet = (dateInfo) => {
  const authUserDetails = useAuthUserDetails();
  if (authUserDetails && authUserDetails.length > 0) {
    this.setState({ authDetails: authUserDetails[0] });
  }
  const authDetails  = authUserDetails[0]

  this.setState({ authDetails, currentViewDate: dateInfo.view.currentStart, isMonthLoading: true }, () => {
    const { userID } = this.state;
    const year = dateInfo.view.currentStart.getFullYear();
    const month = dateInfo.view.currentStart.getMonth() + 1;
    const firstDayOfMonth = `${year}-${String(month).padStart(2, "0")}-01`;

    const formData = new FormData();
    formData.append("date", firstDayOfMonth);
    formData.append("unit_id", authDetails.unit_id);
    formData.append("create_by", userID || (authDetails && authDetails.user_id));

    this.props.fetchEmployeeAttendanceSaga(formData);
  });

  // 🧩 STEP 3: Update toolbar (your existing logic)
  const headerRight = document.querySelector(".fc-toolbar-chunk:last-child");
  if (headerRight) {
    headerRight.innerHTML = Object.entries(statusColors)
      .map(([status, color]) => `
        <span style="
          display:inline-flex;
          align-items:center;
          margin-left:8px;
          font-size:13px;
          font-weight:600;
          color:#2C3E50;
          text-transform:capitalize;
        ">
          <span style="
            width:12px;
            height:12px;
            background:${color};
            border-radius:50%;
            display:inline-block;
            margin-right:6px;
            box-shadow: 0 0 2px rgba(0,0,0,0.3);
          "></span>
          ${status}
        </span>
      `).join("");
  }

  const toolbarLeft = document.querySelector(".fc-toolbar-left");
  if (toolbarLeft) {
    toolbarLeft.style.display = "flex";
    toolbarLeft.style.alignItems = "center";
    toolbarLeft.style.gap = "10px";
  }

  const toolbarTitle = document.querySelector(".fc-toolbar-title");
  if (toolbarTitle) {
    toolbarTitle.style.fontSize = "18px";
    toolbarTitle.style.fontWeight = "700";
  }
};

dayCellDidMount = (info) => {
  const { eventsArray, isMonthLoading, currentViewDate } = this.state;
  if (!currentViewDate || isMonthLoading || !eventsArray || eventsArray.length === 0) return;

  const cellMonth = info.date.getMonth();
  const cellYear = info.date.getFullYear();
  const viewMonth = currentViewDate.getMonth();
  const viewYear = currentViewDate.getFullYear();

  if (cellMonth !== viewMonth || cellYear !== viewYear) return;

  const dateStr = info.date.toISOString().split("T")[0];
  const dayData = eventsArray.find(e => e.start === dateStr);
  if (!dayData) return;

  const status = dayData.extendedProps.status;
  const textColor = dayData.extendedProps.textColor || "#000";

  const bgMap = {
    "Week Off": "#F7F9F9",
    "Holiday": "#E8F8F5",
    "Leave": "#FDEDEC",
    "Permission": "#FEF9E7",
    "Half Day": "#FCF3CF",
    "On Duty": "#F5EEF8",
  };

  const frame = info.el.querySelector(".fc-daygrid-day-frame");
  if (frame) {
    frame.style.backgroundColor = bgMap[status] || "#fff";
    frame.style.color = textColor;
    frame.style.borderRadius = "6px";
    frame.style.boxShadow = "inset 0 0 4px rgba(0,0,0,0.05)";
    frame.style.border = "1px solid #E5E8E8";
  }
};


//   handleEventClick = (e) => {
//   if (e.target.classList.contains("shift-line")) {
//     const date = e.target.getAttribute("data-date");
//     this.openShiftModal(date);
//   } else if (e.target.classList.contains("time-line")) {
//     const date = e.target.getAttribute("data-date");
//     this.openTimeModal(date);
//   }
// };

handleEventClick = (e) => {
  const date = e.target.getAttribute("data-date");

  if (e.target.classList.contains("shift-line")) {
    this.openShiftModal(date);
    this.fetchAttendancePopup(date);
  } else if (e.target.classList.contains("time-line")) {
    this.openTimeModal(date);
    this.fetchAttendancePopup(date);
  } else if (e.target.classList.contains("badge-leave")) {
    // Badge click logic
    const type = e.target.getAttribute("data-type");
    this.handleBadgeClick(type, date); // open Leave/OD/Permission modal
    // this.fetchAttendancePopup(date);    // fetch data
  }
};

fetchAttendancePopup = (date) => {
  const { userID, authDetails } = this.state;

  const formData = new FormData();
  formData.append("date", date);
  formData.append("unit_id", authDetails.unit_id);
  formData.append("create_by", userID || (authDetails && authDetails.user_id));

  this.props.fetchEmployeeAttendancePopupSaga(formData);
};


openShiftModal = (date) => this.setState({ isShiftModalOpen: true, selectedDate: date });
closeShiftModal = () => this.setState({ isShiftModalOpen: false });

openTimeModal = (date) => this.setState({ isTimeModalOpen: true, selectedDate: date });
closeTimeModal = () => this.setState({ isTimeModalOpen: false });

openEmptyCellModal = (date) => this.setState({ isEmptyCellModalOpen: true, selectedDate: date });
closeEmptyCellModal = () => this.setState({ isEmptyCellModalOpen: false });


  render() {

    const { popupData,events, categories } = this.props;
    const { onAddNewEvent, onUpdateEvent } = this.props;
    const { isEdit, deleteModal, event, selectedDay,isMonthLoading,eventsArray } = this.state;
    return (
      <React.Fragment>
        <DeleteModal
          show={deleteModal}
          onDeleteClick={this.handleDeleteEvent}
          onCloseClick={() => this.setState({ deleteModal: false })}
        />
        <div className="page-content">
          <Container fluid={true}>
            {/* Render Breadcrumb */}
            <Breadcrumbs title="Calendar" breadcrumbItem="My Attendance" />
            <Row>
              <Col className="col-12">
                <Card>
                  <CardBody>
                    <Row>
                      {/* <Col lg={3}>
                        <Button
                          color="primary"
                          className="font-16 btn-block btn btn-primary"
                          onClick={this.togglecategory}
                        >
                          <i className="mdi mdi-plus-circle-outline me-1" />
                          Create New Event
                        </Button>

                        <div id="external-events" className="mt-3">
                          <p className="text-muted">
                            Drag and drop your event or click in the calendar
                          </p>
                          {categories &&
                            categories.map((category, i) => (
                              <div
                                key={i}
                                className={`${category.type} external-event text-white p-1 mb-2`}
                                draggable
                                onDrag={event => this.onDrag(event, category)}
                              >
                                <i className="mdi mdi-checkbox-blank-circle me-2 vertical-middle" />
                                {category.title}
                              </div>
                            ))}
                        </div>

                        <div className="mt-5 d-none d-xl-block">
                          <h5 className="text-center">How It Works ?</h5>

                          <ul className="ps-3">
                            <li className="text-muted mb-3">
                              It has survived not only five centuries, but also
                              the leap into electronic typesetting, remaining
                              essentially unchanged.
                            </li>
                            <li className="text-muted mb-3">
                              Richard McClintock, a Latin professor at
                              Hampden-Sydney College in Virginia, looked up one
                              of the more obscure Latin words, consectetur, from
                              a Lorem Ipsum passage.
                            </li>
                            <li className="text-muted mb-3">
                              It has survived not only five centuries, but also
                              the leap into electronic typesetting, remaining
                              essentially unchanged.
                            </li>
                          </ul>
                        </div>
                      </Col> */}
                      <Col >
                        {/* fullcalendar control */}
                        <Row>
                          <Col xs="6">
                            <Label>
                              Employee Code : {this.state.employeeCode}
                            </Label>
                          </Col>

                          <Col xs="6" className="text-end">
                            <Label>
                              Employee Name : {this.state.employeeName}
                            </Label>
                          </Col>
                        </Row>
                          <FullCalendar
                           ref={this.calendarRef}
                          firstDay={1} // Monday start
                          plugins={[BootstrapTheme, dayGridPlugin, interactionPlugin]}
                          slotDuration={"00:15:00"}
                          handleWindowResize={true}
                          themeSystem="bootstrap"
                          headerToolbar={{
                            left: "prev,next",
                            center: "title",
                            right: "statusLegend"
                          }}
                          customButtons={{
                            statusLegend: { text: "", click: () => {} }
                          }}
                          datesSet={this.handleDatesSet}
                          events={this.state.eventsArray}  
                          dayCellDidMount={this.dayCellDidMount}
                          eventContent={this.eventContentFunction}
                           dateClick={this.handleDateClick}
                          eventColor="transparent"
                          eventBorderColor="transparent"
                          eventDisplay="block"
                          editable={false}
                          droppable={false}
                          selectable={true}
                        />

                        {/* New/Edit event modal */}
                        {/* <Modal
                          isOpen={this.state.modal}
                          className={this.props.className}
                          id="event-modal"
                        >
                          <ModalHeader toggle={this.toggle} tag="h4">
                            {!!isEdit ? "Edit Event" : "Add Event"}
                          </ModalHeader>
                          <ModalBody>
                            <Formik
                              enableReinitialize={true}
                              initialValues={{
                                title:
                                  (this.state.event &&
                                    this.state.event.title) ||
                                  "",
                                category:
                                  (this.state.event &&
                                    this.state.event.category) ||
                                  "Danger",
                              }}
                              validationSchema={Yup.object().shape({
                                title: Yup.string().required(
                                  "Please Enter Your Event Name"
                                ),
                                category: Yup.string().required(
                                  "Please Enter Your category"
                                ),
                              })}
                              onSubmit={values => {
                                if (isEdit) {
                                  const updateEvent = {
                                    id: this.state.event.id,
                                    title: values.title,
                                    classNames: values.category + " text-white",
                                    start: this.state.event.start,
                                  };
                                  // update event
                                  onUpdateEvent(updateEvent);
                                } else {
                                  const newEvent = {
                                    id: Math.floor(Math.random() * 100),
                                    title: values["title"],
                                    start: selectedDay
                                      ? selectedDay.date
                                      : new Date(),
                                    className: values.category + " text-white",
                                  };
                                  // save new event
                                  onAddNewEvent(newEvent);
                                }

                                this.setState({ selectedDay: null });
                                this.toggle();
                              }}
                            >
                              {({ errors, status, touched }) => (
                                <Form>
                                  <Row>
                                    <Col xs={12}>
                                      <div className="mb-3">
                                        <Label className="form-label">
                                          Event Name
                                        </Label>
                                        <Field
                                          name="title"
                                          type="text"
                                          className={
                                            "form-control" +
                                            (errors.title && touched.title
                                              ? " is-invalid"
                                              : "")
                                          }
                                        />
                                        <ErrorMessage
                                          name="title"
                                          component="div"
                                          className="invalid-feedback"
                                        />
                                      </div>
                                    </Col>
                                    <Col xs={12}>
                                      <div className="mb-3">
                                        <Label className="form-label">
                                          Select Category
                                        </Label>
                                        <Field
                                          name="category"
                                          as="select"
                                          className={
                                            "form-control" +
                                            (errors.category && touched.category
                                              ? " is-invalid"
                                              : "")
                                          }
                                        >
                                          <option value="bg-danger">
                                            Danger
                                          </option>
                                          <option value="bg-success">
                                            Success
                                          </option>
                                          <option value="bg-primary">
                                            Primary
                                          </option>
                                          <option value="bg-info">Info</option>
                                          <option value="bg-dark">Dark</option>
                                          <option value="bg-warning">
                                            Warning
                                          </option>
                                        </Field>
                                        <ErrorMessage
                                          name="category"
                                          component="div"
                                          className="invalid-feedback"
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col>
                                      <div className="text-end">
                                        <button
                                          type="button"
                                          className="btn btn-light me-2"
                                          onClick={this.toggle}
                                        >
                                          Close
                                        </button>
                                        {!!isEdit && (
                                          <button
                                            type="button"
                                            className="btn btn-danger me-2"
                                            onClick={() =>
                                              this.setState({
                                                deleteModal: true,
                                              })
                                            }
                                          >
                                            Delete
                                          </button>
                                        )}
                                        <button
                                          type="submit"
                                          className="btn btn-success save-event"
                                        >
                                          Save
                                        </button>
                                      </div>
                                    </Col>
                                  </Row>
                                </Form>
                              )}
                            </Formik>
                          </ModalBody>
                        </Modal> */}

                        {/* <Modal
                          isOpen={this.state.modalcategory}
                          toggle={this.togglecategory}
                          className={this.props.className}
                        >
                          <ModalHeader toggle={this.togglecategory} tag="h4">
                            Add a category
                          </ModalHeader>
                          <ModalBody>
                            <Formik
                              enableReinitialize={true}
                              initialValues={{
                                title_category:
                                  (this.state.event &&
                                    this.state.event.title_category) ||
                                  "",
                                event_category:
                                  (this.state.event &&
                                    this.state.event.event_category) ||
                                  "Danger",
                              }}
                              validationSchema={Yup.object().shape({
                                title_category: Yup.string().required(
                                  "Please Enter Your Event Name"
                                ),
                                event_category: Yup.string().required(
                                  "Please Select Your Category"
                                ),
                              })}
                              onSubmit={values => {
                                const newEvent = {
                                  id: Math.floor(Math.random() * 100),
                                  title: values["title_category"],
                                  start: new Date(),
                                  className: values.event_category
                                    ? values.event_category + " text-white"
                                    : "bg-danger text-white",
                                };
                                // save new event
                                onAddNewEvent(newEvent);
                                this.togglecategory();
                              }}
                            >
                              {({ errors, status, touched }) => (
                                <Form>
                                  <Row>
                                    <Col xs={12}>
                                      <div className="mb-3">
                                        <Label className="form-label">
                                          Event Name
                                        </Label>
                                        <Field
                                          name="title_category"
                                          type="text"
                                          className={
                                            "form-control" +
                                            (errors.title_category &&
                                            touched.title_category
                                              ? " is-invalid"
                                              : "")
                                          }
                                        />
                                        <ErrorMessage
                                          name="title_category"
                                          component="div"
                                          className="invalid-feedback"
                                        />
                                      </div>
                                    </Col>
                                    <Col xs={12}>
                                      <div className="mb-3">
                                        <Label className="form-label">
                                          Select Category
                                        </Label>
                                        <Field
                                          name="event_category"
                                          as="select"
                                          className={
                                            "form-control" +
                                            (errors.event_category &&
                                            touched.event_category
                                              ? " is-invalid"
                                              : "")
                                          }
                                        >
                                          <option value="bg-danger">
                                            Danger
                                          </option>
                                          <option value="bg-success">
                                            Success
                                          </option>
                                          <option value="bg-primary">
                                            Primary
                                          </option>
                                          <option value="bg-info">Info</option>
                                          <option value="bg-dark">Dark</option>
                                          <option value="bg-warning">
                                            Warning
                                          </option>
                                        </Field>
                                        <ErrorMessage
                                          name="event_category"
                                          component="div"
                                          className="invalid-feedback"
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col>
                                      <div className="text-end">
                                        <button
                                          type="button"
                                          className="btn btn-light me-2"
                                          onClick={this.togglecategory}
                                        >
                                          Close
                                        </button>
                                        <button
                                          type="submit"
                                          className="btn btn-success save-event"
                                        >
                                          Save
                                        </button>
                                      </div>
                                    </Col>
                                  </Row>
                                </Form>
                              )}
                            </Formik>
                          </ModalBody>
                        </Modal> */}

                        {/* Shift Details Modal */}
                          <Modal
                              isOpen={this.state.isShiftModalOpen}
                              toggle={this.closeShiftModal}
                              
                              size="lg"
                            >
                              <ModalHeader toggle={this.closeShiftModal}>
                                Shift Details
                              </ModalHeader>
                              <ModalBody>
                                {this.props.popupData?.shift_details?.length > 0 ? (
                                  this.props.popupData.shift_details.map((shift, index) => (
                                    <div
                                      key={index}
                                      style={{
                                        padding: "12px",
                                        marginBottom: "12px",
                                        borderRadius: "6px",
                                        backgroundColor: "#f8f9fa",
                                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                      }}
                                    >
                                      {[
                                        ["Shift Code", shift.shift_code],
                                        ["Shift Name", shift.shift_name],
                                        ["Shift Type", shift.shift_type],
                                        ["Shift Date", shift.shift_date],
                                        ["In Time", shift.in_time],
                                        ["Out Time", shift.out_time],
                                        ["Break Out", shift.break_out],
                                        ["Break In", shift.break_in],
                                      ].map(([label, value], i) => (
                                        <div
                                          key={i}
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            marginBottom: "6px",
                                          }}
                                        >
                                          <div style={{ width: "30%", textAlign: "left", fontWeight: 600, color: "#2c3e50" }}>
                                            {label}
                                          </div>
                                          <div style={{ width: "10%", textAlign: "center", fontWeight: 600, color: "#2c3e50" }}>
                                            :
                                          </div>
                                          <div style={{ flex: 1, color: "#34495e" }}>
                                            {value || "-"}
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  ))
                                ) : (
                                  <p style={{ textAlign: "center", color: "#7f8c8d" }}>No shift details available.</p>
                                )}

                              </ModalBody>
                            </Modal>

                          {/* Time (Punch) Details Modal */}
                          <Modal
                            isOpen={this.state.isTimeModalOpen}
                            toggle={this.closeTimeModal}
                            
                            size="lg"
                          >
                            <ModalHeader toggle={this.closeTimeModal}>
                              Punch Details
                            </ModalHeader>
                            <ModalBody>
                              {this.props.loading ? (
                                <p>Loading...</p>
                              ) : this.props.popupData?.punch_details?.length > 0 ? (
                                <div className="table-responsive">
                                  <table className="table table-bordered text-center align-middle">
                                    <thead className="table-light">
                                      <tr>
                                        <th>S.No</th>
                                        <th>Punch Time</th>
                                        <th>Order</th>
                                        <th>Type</th>
                                        <th>Remarks</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {this.props.popupData.punch_details.map((p, idx) => (
                                        <tr key={idx}>
                                          <td>{idx + 1}</td>
                                          <td>{p.punch_time}</td>
                                          <td>{p.punch_order}</td>
                                          <td>{p.punch_type}</td>
                                          <td>{p.remarks}</td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              ) : (
                                <p className="text-center text-muted">No punch details available.</p>
                              )}
                            </ModalBody>
                          </Modal>

                          {/* Modal 3 – Empty Cell Click → with Formik validation */}
                          <Modal
                            isOpen={this.state.modal}
                            toggle={this.toggle}
                            size="xl"
                            
                          >
                            <ModalHeader toggle={this.toggle}>
                              {/* {!!isEdit ? "Edit Event" : "Add Event"} */}
                              {this.state.userID ? "Request Denied" : "Apply Leave / Permission / On duty"}
                            </ModalHeader>

                            <ModalBody style={{ maxHeight: "75vh", overflowY: "auto" }}>
                              {this.state.userID ? (
                              // When userID is present → show denied message
                              <div className="text-center py-5">
                                <h5 className="text-danger fw-bold">Access Restricted!</h5>
                                <p className="text-muted mb-0">
                                  You’re currently viewing the Employee Status page — leave requests can’t be made here.
                                </p>
                              </div>
                            ) : (
                              // When userID is not present → show normal leave form
                              <LeaveApply
                                selectedDay={this.state.selectedDay}
                                onSuccess={this.onLeaveApplySuccess}
                              />
                            )}
                            </ModalBody>
                          </Modal>

                          <Modal
                            isOpen={this.state.isLeaveModalOpen}
                            toggle={this.closeLeaveModal}
                            size="lg"
                          >
                            <ModalHeader toggle={this.closeLeaveModal}>
                              {this.state.leaveModalTitle || "Leave Details"}
                            </ModalHeader>
                            <ModalBody style={{ maxHeight: "70vh", overflowY: "auto", paddingRight: "8px" }}>
                              {this.state.leaveModalData?.length > 0 ? (
                                this.state.leaveModalData.map((item, idx) => (
                                  <div
                                    key={idx}
                                    style={{
                                      padding: "12px",
                                      marginBottom: "12px",
                                      borderRadius: "6px",
                                      backgroundColor: "#f8f9fa",
                                      boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                    }}
                                  >
                                    {[
                                      ["Employee", item.emp_id],
                                      ["Leave Type", item.leave_type],
                                      ["Leave Date", item.leave_dt],
                                      ["No of Days / Hours", item.no_of_days],
                                      ["Reason", item.reason],
                                      ["Status", item.leave_status],
                                      ["Approved By", item.approved_by],
                                      ["Approved Date", item.approved_dt],
                                    ].map(([label, value], i) => (
                                      <div
                                        key={i}
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          marginBottom: "6px",
                                        }}
                                      >
                                        <div style={{ width: "30%", fontWeight: 600, color: "#2c3e50" }}>{label}</div>
                                        <div
                                          style={{
                                            width: "10%",
                                            textAlign: "center",
                                            fontWeight: 600,
                                            color: "#2c3e50",
                                          }}
                                        >
                                          :
                                        </div>
                                        <div style={{ flex: 1, color: "#34495e" }}>{value || "-"}</div>
                                      </div>
                                    ))}
                                  </div>
                                ))
                              ) : (
                                <p style={{ textAlign: "center", color: "#7f8c8d" }}>
                                  No {this.state.leaveModalTitle?.toLowerCase() || "leave"} data available for this date.
                                </p>
                              )}
                            </ModalBody>
                          </Modal>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

MyAttendance.propTypes = {
  fetchEmployeeAttendanceSaga: PropTypes.func,
  categories: PropTypes.array,
  className: PropTypes.string,
  events: PropTypes.array,
  onAddNewEvent: PropTypes.func,
  onDeleteEvent: PropTypes.func,
  onGetCategories: PropTypes.func,
  onGetEvents: PropTypes.func,
  onUpdateEvent: PropTypes.func,
};

const mapStateToProps = ({ calendar }) => ({
  events: calendar.events,
  categories: calendar.categories,
  popupData: calendar.popupData,
  loading: calendar.loading,
});

const mapDispatchToProps = dispatch => ({
  fetchEmployeeAttendanceSaga: (payload) =>
    dispatch({ type: "FETCH_EMPLOYEE_ATTENDANCE_REQUEST", payload }),
  fetchEmployeeAttendancePopupSaga: (payload) =>
    dispatch({ type: "FETCH_EMPLOYEE_ATTENDANCE_POPUP_REQUEST", payload }),
  onGetEvents: () => dispatch(getEvents()),
  onGetCategories: () => dispatch(getCategories()),
  onAddNewEvent: event => dispatch(addNewEvent(event)),
  onUpdateEvent: event => dispatch(updateEvent(event)),
  onDeleteEvent: event => dispatch(deleteEvent(event)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MyAttendance);
